import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LineCommentAltIcon from 'LuxKit/Icons/line/LineCommentAltIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'

function VillasWhyBookWithUs() {
  const intl = useIntl()
  return (
    <Group direction="vertical" gap={32}>
      <Heading variant="heading2" colour="neutral-one">
        {intl.formatMessage({
          id: '2YoCLvI/Wc',
          defaultMessage: 'Why you should book with us',
          description: 'Section heading for why book with us section on the offer detail page',
        })}
      </Heading>
      <Group
        gap={24}
        direction="vertical"
        tabletDirection="horizontal"
        horizontalAlign="start"
        tabletHorizontalAlign="space-between"
      >
        <Group direction="vertical" gap={12}>
          <LineBedDoubleIcon size="L" colour="neutral-one" />
          <Group direction="vertical" gap={4}>
            <BodyText colour="neutral-one" variant="medium" weight="bold">
              {intl.formatMessage({
                id: '9HoBaULFe1',
                defaultMessage: 'Thousands of handpicked villa stays',
                description: 'Heading title for thousands of handpicked villa stays USP',
              })}
            </BodyText>
            <BodyText variant="medium" colour="neutral-one">
              {intl.formatMessage({
                id: 'zTWh82iDWR',
                defaultMessage: 'Unlock a world of premium villa options, handpicked just for you.',
                description: 'Description for thousands of handpicked villa stays USP',
              })}
            </BodyText>
          </Group>
        </Group>
        <Group direction="vertical" gap={12}>
          <LineClockWithTickIcon size="L" colour="neutral-one" />
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold" colour="neutral-one">
              {intl.formatMessage({
                id: 'c9JGRBC0rm',
                defaultMessage: 'Instant booking confirmation',
                description: 'Title for instant booking confirmation USP in the booking flow',
              })}
            </BodyText>
            <BodyText variant="medium" colour="neutral-one">
              {intl.formatMessage({
                id: 'eGoRlLi4Lv',
                defaultMessage: 'Real-time availability for immediate booking confirmation',
                description: 'Description for instant booking confirmation USP on the offer detail page',
              })}
            </BodyText>
          </Group>
        </Group>
        <Group direction="vertical" gap={12}>
          <LineCommentAltIcon size="L" colour="neutral-one" />
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold" colour="neutral-one">
              {intl.formatMessage({
                id: 'Fn/ktaqHqn',
                defaultMessage: '24/7 customer service',
                description: 'Heading title for 24/7 customer service USP on the offer detail page',
              })}
            </BodyText>
            <BodyText variant="medium" colour="neutral-one">
              {intl.formatMessage({
                id: 'JR56hJC2D4',
                defaultMessage: 'Round-the-clock support from our dedicated team',
                description: 'Description for 24/7 customer service USP in the support area',
              })}
            </BodyText>
          </Group>
        </Group>
      </Group>
    </Group>
  )
}

export default VillasWhyBookWithUs
